export enum ModelScreenerFilterType {
  Column = "Column",
  ViaSearch = "ViaSearch",
  ViaMainFilter = "ViaMainFilter",
  Custom = "Custom",
  Range = "Range",
  Checkbox = "Checkbox",
  TrackRecord = "TrackRecord",
  None = "None",
}

export enum ModelScreenerFilterItemType {
  Range = "Range",
  TrackRecord = "TrackRecord",
  SwitchYesNo = "SwitchYesNo",
  SwitchDropdown = "SwitchDropdown",
  SwitchSelect = "SwitchSelect",
  PerformancePeriod = "PerformancePeriod",
  SwitchFavourite = "SwitchFavourite",
}

export enum ModelScreenerFilterSwitchValue
{
  Each = "each",
  Any = "any",
}